import { Component } from '@angular/core';

@Component({
    selector: 'app-consult-note-history-item-title',
    template: '<strong><ng-content /></strong>'
})
export class ConsultNoteHistoryItemTitleComponent {}
